import styled from '@emotion/styled'

export default styled('div')`
  padding-left: ${props => props.theme.spacing['5']};
  color: ${props => props.theme.color.monochrome.mediumDark};
  line-height: 24px;
`
